import { Select } from "antd";
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { idx_data_hole_depth } from "../db/datafixtures/datafixtures";

const dropdownStyle = {
  width: "100%",
  height: 48,
  color: "#00197B",
  marginBottom: "2vh",
};

const ModalHoleDepth = ({
  show,
  numberValue,
  currentValue,
  onHide,
  onChange,
  display_measurement,
}) => {
  const [holeDepth, setHoleDepth] = useState(currentValue || 0);
  const { t } = useTranslation();

  useEffect(() => {
    setHoleDepth(currentValue || 0);
  }, [currentValue]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="confirmDeleteArsenal-popup"
      centered
    >
      <Modal.Header closeButton>
        <div style={{ marginTop: 10 }}>
          <span
            style={{
              fontSize: 14,
              fontFamily: "Poppins",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {t("Set Hole Depth for Hole")}{" "}
            {numberValue === 0
              ? t("Left Hole")
              : numberValue === 1
              ? t("Right Hole")
              : t("Thumb Hole")}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Select
          className="arsenal-select"
          style={dropdownStyle}
          options={idx_data_hole_depth.map((item) => ({
            label:
              display_measurement === "fraction" ? item.fraction : item.decimal,
            value: item.decimal,
          }))}
          value={holeDepth}
          onChange={(value) => {
            setHoleDepth(value);
            onChange(value);
            onHide();
          }}
          getPopupContainer={(triggerNode) => triggerNode.parentElement} // Ensures dropdown renders inside the modal
        />
      </Modal.Body>
    </Modal>
  );
};

export default ModalHoleDepth;
